/* Sväto · Avis produit (bloc svato-reviews-product). Voir assets/CUSTOM.txt. */
// Module partagé chargé par son URL versionnée (asset_url), pour ne jamais servir une version en cache.
const coreUrl = document.querySelector('[data-svato-rv-core]')?.dataset.svatoRvCore || new URL('./svato-reviews-core.js', import.meta.url).href;
const { fetchProductReviews, createReviewList, buildThumb, bindLightbox, fillStars, formatNote, openJudgemeForm, whenJudgemeReady, adoptJudgemeAppBlock } = await import(coreUrl);

class SvatoReviewsProduct extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    try {
      this.swatches = JSON.parse(this.querySelector('[data-rv-swatches]')?.textContent || '{}');
    } catch {
      this.swatches = {};
    }

    adoptJudgemeAppBlock(this);
    bindLightbox(this);
    this.querySelectorAll('[data-rv-write]').forEach((btn) => btn.addEventListener('click', () => this.write(btn)));

    if (location.hash === '#avis-ecrire') {
      whenJudgemeReady(this).then((ok) => ok && openJudgemeForm(this));
    }
    this.load();
  }

  async write(btn) {
    btn.setAttribute('aria-busy', 'true');
    const ready = await whenJudgemeReady(this, 8000);
    btn.removeAttribute('aria-busy');
    if (!ready || !openJudgemeForm(this)) {
      // Repli : l'intégration Judge.me n'a pas chargé son formulaire.
      this.querySelector('[data-rv-jdgm]')?.classList.add('is-visible');
    }
  }

  async load() {
    try {
      // Avis importés d'une autre plateforme : masqués sauf réglage « Afficher les avis importés ».
      this.data = await fetchProductReviews(this.dataset.shop, this.dataset.productId, { includeImported: this.dataset.showImported === 'true' });
      this.renderSummary();
      this.syncTopRating();
      this.classList.remove('is-loading');
      const source = this.querySelector('[data-rv-source]');
      if (source) source.hidden = !this.data.reviews.some((r) => r.imported);
      this.renderPhotos();
      if (this.data.count) {
        createReviewList(this, this.querySelector('.svato-rv__main'), {
          reviews: this.data.reviews,
          perPage: Number(this.dataset.perPage) || 3,
          cardOptions: { swatches: this.swatches, variantPrefix: this.dataset.variantPrefix },
        });
      }
    } catch (err) {
      // Repli : le widget Judge.me officiel reste utilisable, on l'affiche tel quel.
      console.warn('[svato-reviews]', err);
      this.classList.remove('is-loading');
      this.classList.add('is-fallback');
      const holder = this.querySelector('[data-rv-jdgm]');
      holder?.classList.add('is-visible');
      holder?.removeAttribute('inert');
      this.querySelector('[data-rv-list]')?.replaceChildren();
    }
  }

  /**
    Étoiles du haut de fiche (bloc natif rating-stars) : elles lisent les métachamps Shopify, que
    Judge.me met à jour avec du retard. On aligne leur note et leur nombre sur les données en direct.
  */
  syncTopRating() {
    const { count, average } = this.data;
    document.querySelectorAll('.rating').forEach((rating) => {
      if (this.contains(rating) || rating.closest('product-card, .svato-card')) return;
      const holder = rating.closest('.rating-stars-block, [class*="rating-stars"]') || rating;
      if (!count) {
        holder.hidden = true;
        return;
      }
      const note = rating.querySelector('.rating__note');
      if (note) note.textContent = `${Math.round(average * 100) / 100}/5`;
      const n = rating.querySelector('.rating__count');
      if (n) n.textContent = n.textContent.replace(/\d+/, String(count));
    });
  }

  renderSummary() {
    const { count, average, histogram } = this.data;
    this.classList.toggle('is-empty', count === 0);
    const avg = this.querySelector('[data-rv-avg]');
    if (avg) avg.textContent = formatNote(average);
    const stars = this.querySelector('[data-rv-summary-stars]');
    if (stars) fillStars(this, stars, average);
    const label = this.querySelector('[data-rv-count]');
    if (label) label.textContent = (this.dataset.countLabel || '[n] avis').replace('[n]', count);

    const hist = this.querySelector('[data-rv-hist]');
    if (hist && count > 0 && histogram.length) {
      hist.replaceChildren();
      [...histogram].sort((a, b) => b.rating - a.rating).forEach((h) => {
        const row = document.createElement('li');
        row.className = 'svato-rv-hist__row';
        row.innerHTML = '<span class="svato-rv-hist__label"></span><span class="svato-rv-hist__bar"><span></span></span><span class="svato-rv-hist__value"></span>';
        row.children[0].textContent = `${h.rating}★`;
        row.children[1].firstElementChild.style.width = `${h.percentage}%`;
        row.children[2].textContent = String(h.frequency);
        row.setAttribute('aria-label', `${h.rating} étoiles : ${h.frequency} avis`);
        hist.append(row);
      });
      hist.hidden = false;
    }
  }

  renderPhotos() {
    const wrap = this.querySelector('[data-rv-photo-block]');
    const grid = this.querySelector('[data-rv-photo-grid]');
    if (!wrap || !grid) return;
    const pics = this.data.reviews.flatMap((r) => r.pictures.map((p) => ({ p, name: r.name })));
    if (!pics.length) return;
    grid.replaceChildren(...pics.slice(0, 9).map(({ p, name }, i) => buildThumb(this, p, `Photo client ${i + 1} (${name || 'client'})`)));
    wrap.hidden = false;
  }
}

if (!customElements.get('svato-reviews-product')) customElements.define('svato-reviews-product', SvatoReviewsProduct);
